if (!customElements.get('frequently-bought')) {
  class FrequentlyBought extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-fbt-add]');
      if (!this.button) return;
      this.onClick = this.onAdd.bind(this);
      this.button.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this.onClick);
    }

    async onAdd() {
      if (this.button.disabled || this.pending) return;
      const error = this.querySelector('[data-fbt-error]');
      const spinner = this.querySelector('.loading__spinner');
      if (error) error.hidden = true;

      try {
        const values = JSON.parse(this.dataset.variantIds || '[]');
        const ids = [...new Set(values.map(String).filter((id) => /^\d+$/.test(id)))];
        if (!ids.length) return;

        this.pending = true;
        this.button.disabled = true;
        this.button.setAttribute('aria-disabled', 'true');
        this.button.classList.add('loading');
        spinner?.classList.remove('hidden');

        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(this.dataset.cartAddUrl || root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: ids.map((id) => ({ id, quantity: 1 })) }),
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(this.dataset.errorMessage);
        window.location.assign(this.dataset.cartUrl || root + 'cart');
      } catch (e) {
        if (error) {
          error.textContent = this.dataset.errorMessage || window.cartStrings?.error || '';
          error.hidden = false;
        }
      } finally {
        this.pending = false;
        this.button.disabled = false;
        this.button.removeAttribute('aria-disabled');
        this.button.classList.remove('loading');
        spinner?.classList.add('hidden');
      }
    }
  }

  customElements.define('frequently-bought', FrequentlyBought);
}
